import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { Subject } from 'rxjs';
import { QQQuestionViewModel } from 'src/app/models/qq-question.view-model';

@Component({
  selector: 'app-email-question',
  templateUrl: './email-question.component.html',
  styleUrls: ['./email-question.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class EmailQuestionComponent implements OnInit, OnDestroy {
  @Input() question: QQQuestionViewModel;
  @ViewChild('input') input: ElementRef<HTMLInputElement>;

  rgx = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/i;
  dispose$ = new Subject();

  constructor(
  ) {
  }

  ngOnInit() {
    this.question.beforeSubmit(
      this.dispose$,
      e => {
        if (this.input.nativeElement.value != this.question.answer)
          e.add(async () => {
            this.question.editingValue = this.input.nativeElement.value;
            return await this.save();
          })
      }
    );
  }

  ngOnDestroy(): void {
    this.dispose$.next(null);
  }

  async save() {
    if (!this.question.editingValue) {
      this.question.error = 'Please enter an email address';
      return false;
    }
    else if (!this.rgx.test(this.question.editingValue)) {
      this.question.error = 'Please enter a valid email address';
      return false;
    }
    else
      return await this.question.setAnswer(this.question.editingValue, true);
  }

}
